import Footer from './Footer';
import Logo from './Logo';

Logo.Header = Logo;
Logo.Footer = Footer;

export { Logo };
